module.exports = "<!--Scroll to top-->\n<div class=\"scrollTop__container\" [ngClass]=\"{'scrollTop--show': showScrollTopButton}\">\n    <i (click)=\"scrollToTop()\" class=\"icon--moderate-blue chevron-up icon-stack-2x-special\" title=\"nach oben\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/scroll-top-button/scroll-top-button.html
// module id = VM0i
// module chunks = 12